"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M5 5.5A2.5 2.5 0 0 1 7.5 3h7a.5.5 0 0 1 .354.146l4 4A.5.5 0 0 1 19 7.5v11a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 5 18.5zm10-.793V6.5a.5.5 0 0 0 .5.5h1.793zM14 10.5v7a.5.5 0 0 0 1 0v-7a.5.5 0 0 0-1 0m-2 2a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0zm-3 2a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0z"
}), 'ReportFilled');
//# sourceMappingURL=index.js.map